var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3153 9.95531C25.1763 10.167 25.853 10.7884 26.0835 11.5791C26.5 13.0108 26.5 15.9999 26.5 15.9999C26.5 15.9999 26.5 18.9889 26.0818 20.4206C25.8513 21.2114 25.1747 21.8327 24.3136 22.0444C22.7545 22.4284 16.5 22.4284 16.5 22.4284C16.5 22.4284 10.2455 22.4284 8.68637 22.0444C7.82532 21.8327 7.14867 21.2114 6.91818 20.4206C6.5 18.9889 6.5 15.9999 6.5 15.9999C6.5 15.9999 6.5 13.0108 6.91818 11.5791C7.14867 10.7884 7.82532 10.167 8.68637 9.95531C10.2455 9.57129 16.5 9.57129 16.5 9.57129C16.5 9.57129 22.7545 9.57129 24.3153 9.95531ZM20.0717 15.9997L14.3574 13.1426V18.8569L20.0717 15.9997Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4db59fe97a9466d8122c11369bbc4232.svg";
export { ForwardRef as ReactComponent };